import request from '../../request'
import {safeSpace} from '../../endpoints'

export const getStaffByStudentId = (studentId, schoolId) => {
  return request({
    url: safeSpace.GetStaffByStudentId(studentId, schoolId),
    method: 'GET',
  })
    .then(response => response)
    .catch(error => error)
}

export const GetSafeSpaceConversationsbyStudentId = (model) => {
  return request({
    url: safeSpace.GetSafeSpaceConversationsbyStudentId,
    method: 'POST',
    data: model,
  })
    .then((response) => response)
    .catch((response) => response);
};

export const getStaffConversationsMessagesById = (conversationId, isMAT, groupId, schoolId, afterMessageId = null) => {
  return request({
    url: safeSpace.getStaffConversationsMessagesById(conversationId, isMAT, groupId, schoolId, afterMessageId),
    method: 'GET',
  })
    .then((response) => response)
    .catch((response) => response);
};

export const AddConversationsMessagesReplies = (model) => {
  return request({
    url: safeSpace.AddConversationsMessagesReplies,
    method: 'POST',
    data: model,
  })
    .then((response) => response)
    .catch((response) => response);
};

const submitSafeSpaceConversation = ({ conversation }) => { 
  return request({
    url: safeSpace.submitSafeSpaceConversation,
    method: 'POST',
    data: conversation,
  }).then((response) => response);
};


// const StudentConversationSeen = ({ conversation }) => {
//  debugger;  
//   return request({
//     url: safeSpace.StudentConversationSeen,
//     method: 'POST',
//     data: conversation,
//   }).then((response) => response);
// };

export const StudentConversationSeen = (conversation) => {
  return request({
    url: safeSpace.StudentConversationSeen,
    method: 'POST',
    data: conversation,
  })
    .then((response) => response)
    .catch((response) => response);
};


export const getSafeSpaceSettings = (schoolId,groupId,isMAT) => {
  //debugger;
  return request({
    url: safeSpace.GetSafeSpaceSettings(schoolId,groupId,isMAT),
    method: 'GET',
  })
    .then(response => response)
    .catch(error => error)
}

export const getHolidays = (schoolId,matId) => {  
  return request({
    url: safeSpace.getHolidays(schoolId,matId),
    method: 'GET',
  })
    .then(response => response)
    .catch(error => error)
}

export const checkStudentInSafeSpaceAndHasCheckin = (
  schoolId,
  matId,
  studentId
) => {
  return request({
    url: safeSpace.CheckStudentInSafeSpaceAndHasCheckin(
      schoolId,
      matId,
      studentId
    ),
    method: 'GET',
  })
    .then(response => response)
    .catch(error => error)
}

export const safeSpaceApi = {
  getStaffByStudentId,
  GetSafeSpaceConversationsbyStudentId,
  AddConversationsMessagesReplies,
  getStaffConversationsMessagesById,
  getSafeSpaceSettings,
  checkStudentInSafeSpaceAndHasCheckin,
  submitSafeSpaceConversation,
  StudentConversationSeen,
  getHolidays,
}

export default safeSpaceApi
